module.exports = __webpack_public_path__ + "images/file_icons_v2/cgi-fd8fbc6c61df32cc4a345e0bcc8e2451.svg";